import * as TFF from '@tff/types/TFF';
import { NDC_AND_NDCX_BOOKING_SOURCES } from '../constants/booking-sources';

export const isNdcFlightOnlyBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  return (
    !!retrieveItem?.bookingSource &&
    ['AF', 'KL', 'SQ', 'EK', 'NDCX'].includes(retrieveItem.bookingSource) &&
    retrieveItem.product !== 'atcomres' &&
    retrieveItem.product !== 'atcomnr'
  );
};

export const isTTSBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  const promoCode = retrieveItem?.reservationSystemDetails?.['atcomres_cr']?.promoCode;
  return retrieveItem?.product === 'atcomres' && (promoCode === '0500' || promoCode === '0499');
};

export const isNdcBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  return !!retrieveItem?.bookingSource && ['AF', 'KL'].includes(retrieveItem.bookingSource);
};

export const isNskBookingSource = (bookingSource: TFF.TffBookingSource): boolean => {
  return (['TUI-NSK'] as TFF.TffBookingSource[]).includes(bookingSource);
};

export const isNdcOrNdcxBookingSource = (bookingSource: TFF.TffBookingSource): boolean => {
  return NDC_AND_NDCX_BOOKING_SOURCES.includes(bookingSource);
};

export const isNskBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  return !!retrieveItem?.bookingSource && ['NSK'].includes(retrieveItem.bookingSource);
};

export const hasTariffType = (retrieveItem: TFF.Retrieve, tariffType: string): boolean => {
  return !!retrieveItem?.tariffType && retrieveItem?.tariffType?.toUpperCase() === tariffType.toUpperCase();
};

export const isAtcomresBooking = (retrieveItem?: TFF.Retrieve): boolean => {
  return retrieveItem?.product === 'atcomres';
};
